import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../../app.service';
import { KpiGroupService } from '../kpi-group.service';
import { SiFiltersService } from '../../../filter/si-filters.service';
declare let d3;

@Component({
  selector: 'si-kpi-group',
  templateUrl: './kpi-group.component.html',
  styleUrls: ['./kpi-group.component.scss']
})
export class KpiGroupComponent implements OnInit {
  @Input() kpiConfigs: Array<object>;

  constructor(private appService: AppService, private siFiltersService: SiFiltersService, private kpiGroupService: KpiGroupService) { }

  ngOnInit() {
  }

  shortenLargeNumber(num, digits) {
    let SI_SYMBOL, tier, suffix, scale, scaled;
    SI_SYMBOL = ['', 'K', 'M', 'B', 'T', 'P', 'E'];
    // what tier? (determines SI symbol)
    // tslint:disable:no-bitwise
    tier = Math.log10(num) / 3 | 0;

    // if zero, we don't need a suffix
    if (tier === 0) { return num; }

    // get suffix and determine scale
    suffix = SI_SYMBOL[tier];
    scale = Math.pow(10, tier * 3);

    // scale the number
    scaled = num / scale;
    // format number, check if precision zero and add suffix
    return scaled.toFixed(1) + suffix;

  }

}
